import * as React from "react";

import { cn } from "../../lib/utils.js";
import { Label } from "./label.js";

export interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
  description?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
}

export const Field = ({
  label,
  description,
  error,
  htmlFor,
  required,
  className,
  children,
  ...props
}: FieldProps) => (
  <div className={cn("grid gap-2", className)} {...props}>
    {label !== undefined && (
      <Label htmlFor={htmlFor} className="flex items-center gap-1">
        {label}
        {required ? (
          <span className="text-destructive" aria-hidden>
            *
          </span>
        ) : null}
      </Label>
    )}
    {children}
    {error ? (
      <p className="text-xs text-destructive" role="alert">
        {error}
      </p>
    ) : description ? (
      <p className="text-xs text-muted-foreground">{description}</p>
    ) : null}
  </div>
);
